import { Button, Flex, useColorModeValue, Spinner } from '@chakra-ui/react';

import { useCallback } from 'react';

import { useDropzone } from 'react-dropzone';

function Dropzone(props: {
  content: JSX.Element | string;
  handleFileUpload: Function;
  isLoading?: boolean;
}) {
  const { handleFileUpload, content, isLoading } = props;

  const borderColor = useColorModeValue('gray.300', 'whiteAlpha.100');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const bgColor = useColorModeValue('white', 'navy.700');

  const onDrop = useCallback(
    (acceptedFiles: any) => {
      handleFileUpload(acceptedFiles);
    },
    [handleFileUpload],
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: 'application/pdf',
    disabled: isLoading,
  });

  return (
    <Flex
      align="center"
      justify="center"
      border="1px dashed"
      borderColor={borderColor}
      borderRadius="16px"
      h="200px"
      cursor="pointer"
      bg={bgColor}
      {...getRootProps({ className: 'dropzone' })}
    >
      {isLoading && <Spinner size="xl" color={textColor} />}

      {!isLoading && (
        <>
          <input {...getInputProps()} />
          <Button variant="no-effects">{content}</Button>
        </>
      )}
    </Flex>
  );
}

export default Dropzone;
